import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=2c4e0640&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=2c4e0640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e0640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4e0640')) {
      api.createRecord('2c4e0640', component.options)
    } else {
      api.reload('2c4e0640', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=2c4e0640&scoped=true&", function () {
      api.rerender('2c4e0640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Tag.vue"
export default component.exports